export const HTTP_METHODS = ["GET", "PATCH", "DELETE", "POST", "PUT"];
